// /settings — index route. Renders the cards-grid landing
// (`pages/settings/index.tsx`). Child routes like /settings/users are
// handled by their own file routes which mount inside the settings.tsx
// layout's <Outlet />.

import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const SettingsPage = lazy(() => import('@/pages/settings'));

export const Route = createFileRoute('/settings/')({
  component: function SettingsIndexRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <SettingsPage />
      </Suspense>
    );
  },
});
